// Series and player colours — mirrors --egdl-series-N / --egdl-player-N in styles/tokens.css.
// Series colours follow selection order; every third line also changes dash so lines read without colour.
export const PALETTE = {
    light: ['#0F6E8C', '#9A6200', '#6B4BA8', '#1E7A4B', '#B3305F', '#3B5BB5', '#6F6A12', '#5C6670'],
    dark: ['#38C0E8', '#E0A54A', '#B49AF0', '#4CC38A', '#F07FA8', '#8FA8F5', '#C9C25A', '#AEB7BE'],
};
export const DASHES = ['', '7 4', '2 3'];
// Player identity P1–P6: hues between the series hues, deeper in light / lighter in dark; always paired with a P-label.
export const PLAYERS = {
    light: ['#B4561A', '#1F7A80', '#A3338F', '#5146B0', '#4E7A1E', '#7A5A3A'],
    dark: ['#F0955A', '#5CC8CE', '#E27FD0', '#A29BF2', '#9CCB5E', '#C9A27F'],
};
export const seriesColor = (idx, theme = 'light') => (PALETTE[theme] || PALETTE.light)[idx % 8];
export const dashOf = (idx) => DASHES[idx % 3];
export const playerHex = (slot, theme = 'light') => (PLAYERS[theme] || PLAYERS.light)[(Math.max(1, slot) - 1) % 6];
